import api from './api';

export interface GrupoMcp {
    grupoMcp: number;
    descripcion: string;
    plantilla?: string;
    impresora?: string | null;
    vistaPrevia?: string;
    copias?: number;
    grupoMcpDestino?: number;
    [key: string]: any; // Para campos adicionales que puedan venir del backend
}

export interface GrupoMcpSearchParams {
    searchTerm?: string;
    pageNumber: number;
    pageSize: number;
}

export interface GrupoMcpPagedResult {
    items: GrupoMcp[];
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
}

const grupoMcpService = {
    getGruposMcp: async (params: GrupoMcpSearchParams): Promise<GrupoMcpPagedResult> => {
        const response = await api.get<GrupoMcpPagedResult>('/api/GrupoMcp', { 
            params: {
                SearchTerm: params.searchTerm,
                PageNumber: params.pageNumber,
                PageSize: params.pageSize
            }
        });
        return response.data;
    },

    getGrupoMcp: async (grupoMcp: number): Promise<GrupoMcp> => {
        const response = await api.get<GrupoMcp>(`/api/GrupoMcp/${grupoMcp}`);
        return response.data;
    },

    createGrupoMcp: async (grupoMcp: GrupoMcp): Promise<GrupoMcp> => {
        const response = await api.post<GrupoMcp>('/api/GrupoMcp', grupoMcp);
        return response.data;
    },

    updateGrupoMcp: async (grupoMcp: number, grupoMcpData: GrupoMcp): Promise<void> => {
        await api.put(`/api/GrupoMcp/${grupoMcp}`, grupoMcpData);
    },

    deleteGrupoMcp: async (grupoMcp: number): Promise<void> => {
        await api.delete(`/api/GrupoMcp/${grupoMcp}`);
    },

    getUsuariosGrupoMcp: async (grupoMcp: number): Promise<any[]> => {
        const response = await api.get<any[]>(`/api/GrupoMcp/${grupoMcp}/usuarios`);
        return response.data;
    },

    addUsuarioGrupoMcp: async (grupoMcp: number, usuario: string): Promise<void> => {
        await api.post(`/api/GrupoMcp/${grupoMcp}/usuarios/${usuario}`);
    },

    removeUsuarioGrupoMcp: async (grupoMcp: number, usuario: string): Promise<void> => {
        await api.delete(`/api/GrupoMcp/${grupoMcp}/usuarios/${usuario}`);
    }
};

export default grupoMcpService;

